/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2018, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS 'AS IS' AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'

import {
  Button,
  ToolbarItem,
  ResponsibilityIdentities,
  DockedFormFooter,
  SvgIcon
} from '../'

export default class AssignedToResponsibilityIdentity extends React.PureComponent {
  static propTypes = {
    identityId: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    responsibility: PropTypes.string.isRequired,
    openDropdown: PropTypes.bool,
    closeDropdown: PropTypes.func,
    assignedToSave: PropTypes.func.isRequired,
    onAssignClick: PropTypes.func,
    onUnassignClick: PropTypes.func,
    excludeIdentity: PropTypes.string,
    onClick: PropTypes.func,
    disabled: PropTypes.bool
  }

  constructor(props) {
    super(props)

    this.state = {
      assignedTo: props.identityId
    }

    this.toolbarRef = React.createRef()
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside)
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside)
  }

  handleClickOutside = (e) => {
    if (this.toolbarRef.current.contains(e.target)) {
      // click is inside drop-down, drop-down stays open
      return
    }
    // click is outside, close drop-down
    this.setState({ assignedTo: this.props.identityId })
    this.props.closeDropdown()
  }

  render() {
    let { identityId, firstName, lastName, responsibility, assignedToSave, dropdownOpen, excludeIdentity, onClick, noUnassign, disabled } = this.props
     return (
      <ToolbarItem
        label='Assigned to'
        value={
          <div className='request-assigned-to__name'>
            {identityId
              ? `${firstName} ${lastName}`
              : 'No one'
            }
          </div>
        }
        dropdownContent={
          <div ref={this.toolbarRef} className='request-assigned-to__dropdown'>
            <div style={{ height: 260 }}>
              <ResponsibilityIdentities
                assignedTo={this.state.assignedTo}
                responsibility={responsibility}
                onSelect={assignedTo => this.setState({ assignedTo })}
                excludeIdentity={excludeIdentity}
                className='slds-p-around_medium slds-m-top_x-small slds-scrollable_y'
              />
            </div>
            <DockedFormFooter>
              <Button
                minWidth={55}
                onClick={e => {
                  e.stopPropagation()
                  assignedToSave(this.state.assignedTo)
                }}
                disabled={this.state.assignedTo === identityId || disabled}>
                {identityId ? 'Reassign': 'Assign'}
              </Button>
              {!noUnassign &&
                <Button
                  minWidth={55}
                  onClick={e => {
                    e.stopPropagation()
                    assignedToSave('null')  // the mutation in parent requires "null" (as string) to unset requestrun.assignedTo
                  }}>
                  Unassign
                </Button>
              }
            </DockedFormFooter>
          </div>
        }
        dropdownOpen={dropdownOpen}
        onDropdownClick={disabled ? () => false : onClick}
        className='request-assigned-to'>
        <SvgIcon
          variant='utility'
          symbol='chevrondown'
          size='x-small'
          colour={disabled ? 'light' : 'default'}
        />
      </ToolbarItem>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/assigned-to-responsibility-identity/index.js